import queryString, { type Stringifiable } from 'query-string';

export const stringifyUrl = ({ url, query }: { url: string; query: Record<string, Stringifiable> }): string => {
  return queryString.stringifyUrl({ url, query }, { skipEmptyString: true, skipNull: true });
};

/**
 * Removes host from URL and returns only the relative path and search params.
 * Useful for robust internal redirects agnostic of environment.
 */
export const convertUrlToRelativePath = (url: URL): string => {
  return `${url.pathname}${url.search}`;
};
